import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { format } from "date-fns";

export const generateMtoReport = (ticket) => {
  const doc = new jsPDF('p', 'pt', 'a4');

  // Colores corporativos (según las imágenes)
  const colors = {
    blueDark: [15, 36, 76], // Azul oscuro para cabeceras de tablas
    red: [227, 24, 24],     // Rojo para sub-cabeceras
    border: [0, 0, 0]       // Bordes negros/grises
  };

  // Cabecera superior
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  
  // Título (Ajustar posiciones x, y)
  doc.text('REPORTE DE MANTENIMIENTOS PREVENTIVOS, CORRECTIVOS E INSTALACIONES', 130, 40);

  // Tabla cabecera (Código, Fecha, Versión)
  doc.autoTable({
    startY: 60,
    head: [],
    body: [
      ['Código: FO-MTO-03', `Fecha: ${format(new Date(), "yyyy-MM-dd")}`, 'Versión 9']
    ],
    theme: 'grid',
    styles: { 
      halign: 'center', 
      valign: 'middle', 
      fontSize: 9,
      textColor: [0, 0, 0],
      lineColor: colors.blueDark,
      lineWidth: 1
    },
    columnStyles: {
      0: { cellWidth: 150 },
      1: { cellWidth: 200 },
      2: { cellWidth: 'auto' }
    },
    margin: { left: 40, right: 40 }
  });

  // A. REPORTE DE LA ACTIVIDAD A EJECUTAR
  doc.autoTable({
    startY: doc.lastAutoTable.finalY + 10,
    head: [[
      { content: 'A. REPORTE DE LA ACTIVIDAD A EJECUTAR', colSpan: 3, styles: { fillColor: colors.blueDark, textColor: 255, fontStyle: 'bold' } },
      { content: `Nº DE ORDEN: ${ticket.TicketId}`, colSpan: 1, styles: { fillColor: colors.blueDark, textColor: 255, fontStyle: 'bold' } }
    ]],
    body: [
      [
        { content: '1. EQUIPO / ACCESORIO / DISPOSITIVO', styles: { fillColor: colors.red, textColor: 255, fontStyle: 'bold' } },
        { content: '2. UBICACIÓN', styles: { fillColor: colors.red, textColor: 255, fontStyle: 'bold' } },
        { content: '3. CÓDIGO DE INVENTARIO', styles: { fillColor: colors.red, textColor: 255, fontStyle: 'bold' } },
        { content: '4. FECHA Y HORA', styles: { fillColor: colors.red, textColor: 255, fontStyle: 'bold' } }
      ],
      [
        ticket.equipo || 'N/A',
        'N/A', // Ubicación no disponible directamente
        ticket.cod || 'N/A',
        format(new Date(ticket.fecha), "dd/MM/yyyy HH:mm")
      ],
      [
        { content: '5. DESCRIPCIÓN DE LA FALLA O ACTIVIDAD A EJECUTAR', colSpan: 4, styles: { fillColor: colors.blueDark, textColor: 255, fontStyle: 'bold' } }
      ],
      [
        { content: ticket.observacion || '', colSpan: 4, styles: { minCellHeight: 40 } }
      ]
    ],
    theme: 'grid',
    styles: { 
      fontSize: 8,
      lineColor: colors.blueDark,
      lineWidth: 1
    },
    margin: { left: 40, right: 40 }
  });

  // Extraer información de resolución
  const resolucion = ticket.fullHistorial?.find(r => r.EstadoId === 4)?.resolucion || {};
  
  const isPreventivo = resolucion.tipo_mantenimiento === 'Preventivo' ? 'X' : '';
  const isCorrectivo = resolucion.tipo_mantenimiento === 'Correctivo' ? 'X' : '';
  const isOtroMto = (!isPreventivo && !isCorrectivo) ? 'X' : '';
  
  // B. ACCIÓN DE MANTENIMIENTO
  doc.autoTable({
    startY: doc.lastAutoTable.finalY + 5,
    head: [[
      { content: 'B. ACCIÓN DE MANTENIMIENTO (Uso Exclusivo del Proceso de Mantenimiento)', colSpan: 4, styles: { fillColor: colors.blueDark, textColor: 255, fontStyle: 'bold' } }
    ]],
    body: [
      [
        { content: '1. TIPO DE MANTENIMIENTO:', styles: { fillColor: colors.red, textColor: 255, fontStyle: 'bold' } },
        `PREVENTIVO:  ${isPreventivo}`,
        `CORRECTIVO:  ${isCorrectivo}`,
        `OTRO:  ${isOtroMto}`
      ],
      [
        { content: 'MANTENIMIENTO REALIZADO:', styles: { fillColor: colors.red, textColor: 255, fontStyle: 'bold' } },
        `PERSONAL INTERNO:  X`, // Asumido
        { content: `CONTRATISTA:  `, colSpan: 2 }
      ],
      [
        { content: '2. FALLA DETECTADA O ACTIVIDAD A EJECUTAR:', colSpan: 4, styles: { fillColor: colors.blueDark, textColor: 255, fontStyle: 'bold' } }
      ],
      [
        { content: ticket.observacion || '', colSpan: 4, styles: { minCellHeight: 30 } }
      ],
      [
        { content: '3. VERIFICACIÓN DEL EQUIPO:', colSpan: 4, styles: { fillColor: colors.blueDark, textColor: 255, fontStyle: 'bold' } }
      ],
      [
        { content: 'VOLT DE PLACA:', styles: { fontStyle: 'bold' } },
        resolucion.revvoltaje || 'N/A',
        { content: 'OBSERVACIÓN:', rowSpan: 2, styles: { valign: 'middle', halign: 'center' } },
        { content: resolucion.observaciones_gen || 'N/A', rowSpan: 2 }
      ],
      [
        { content: 'VOLT DE ENTRADA:', styles: { fontStyle: 'bold' } },
        'N/A' // No disponible específico
      ],
      [
        { content: '3.1. VERIFICACIÓN DEL EQUIPO (APLICA SOLO PARA EQUIPOS DE REFRIGERACIÓN O SIMILARES):', colSpan: 4, styles: { fillColor: colors.blueDark, textColor: 255, fontStyle: 'bold' } }
      ],
      [
        'CAPACIDAD (BTU): N/A',
        'REFRIGERANTE: N/A',
        'PRESIÓN (PSI): N/A',
        'N/A'
      ],
      [
        { content: '4. DESCRIPCIÓN DE LA ACCIÓN REALIZADA:', colSpan: 4, styles: { fillColor: colors.blueDark, textColor: 255, fontStyle: 'bold' } }
      ],
      [
        { 
          content: `Revisión general de funcionamiento: ${resolucion.revgenfuncion ? 'X' : ''}\nLimpieza general: ${resolucion.limpgeneral ? 'X' : ''}\nAjustes de partes: ${resolucion.ajustes ? 'X' : ''}\nRevisión del sistema de enfriamiento: ${resolucion.revsisenfriamiento ? 'X' : ''}`, 
          colSpan: 2,
          styles: { minCellHeight: 40 }
        },
        { 
          content: `Lubricación: ${resolucion.lubricacion ? 'X' : ''}\nOtras: ${resolucion.otra_actividad || ''}`, 
          colSpan: 2 
        }
      ],
      [
        { content: '5. REPUESTOS REQUERIDOS O UTILIZADOS:', colSpan: 4, styles: { fillColor: colors.blueDark, textColor: 255, fontStyle: 'bold' } }
      ],
      [
        { content: resolucion.repuesto ? `${resolucion.repuesto} ${resolucion.otro_repuesto || ''}` : 'Ninguno', colSpan: 4, styles: { minCellHeight: 30 } }
      ],
      [
        { content: '6. OBSERVACIONES FINALES Y RECOMENDACIONES:', colSpan: 4, styles: { fillColor: colors.blueDark, textColor: 255, fontStyle: 'bold' } }
      ],
      [
        { content: resolucion.observaciones_gen || 'N/A', colSpan: 4, styles: { minCellHeight: 30 } }
      ],
      [
        { content: '7. EL EQUIPO REQUIERE MONITOREO DESPUÉS DEL MANTENIMIENTO REALIZADO:', colSpan: 2, styles: { fillColor: colors.blueDark, textColor: 255, fontStyle: 'bold' } },
        { content: `SI:   NO: X`, colSpan: 1, styles: { fillColor: colors.blueDark, textColor: 255, fontStyle: 'bold' } },
        { content: `NOTA: En caso afirmativo describir la actividad.`, colSpan: 1, styles: { fillColor: colors.blueDark, textColor: 255, fontStyle: 'bold' } }
      ],
      [
        { content: 'No requiere monitoreo', colSpan: 4, styles: { minCellHeight: 30 } }
      ],
      [
        { content: `8. ACTIVIDAD REALIZADA EN COMPAÑÍA: SI: ${resolucion.en_compania ? 'X' : ''}  NO: ${!resolucion.en_compania ? 'X' : ''}`, colSpan: 2, styles: { fillColor: colors.blueDark, textColor: 255, fontStyle: 'bold' } },
        { content: `9. Nº DE PERSONAS: ${resolucion.num_personas || ''}`, colSpan: 1, styles: { fillColor: colors.blueDark, textColor: 255, fontStyle: 'bold' } },
        { content: '10. HORAS HOMBRE DE TRABAJO:', colSpan: 1, styles: { fillColor: colors.blueDark, textColor: 255, fontStyle: 'bold' } }
      ]
    ],
    theme: 'grid',
    styles: { 
      fontSize: 7.5,
      lineColor: colors.blueDark,
      lineWidth: 1
    },
    margin: { left: 40, right: 40 }
  });
  
  // Footer Firmas
  doc.autoTable({
    startY: doc.lastAutoTable.finalY,
    head: [[
      { content: '11. FECHA Y HORA DE INICIO MANTENIMIENTO', colSpan: 2, styles: { fillColor: colors.blueDark, textColor: 255, fontStyle: 'bold' } },
      { content: '15. FECHA Y HORA DE TERMINACIÓN DEL MANTENIMIENTO:', colSpan: 2, styles: { fillColor: colors.blueDark, textColor: 255, fontStyle: 'bold' } }
    ]],
    body: [
      [
        { content: 'FECHA', styles: { fillColor: colors.red, textColor: 255, fontStyle: 'bold' } },
        { content: 'HORA', styles: { fillColor: colors.red, textColor: 255, fontStyle: 'bold' } },
        { content: 'FECHA', styles: { fillColor: colors.red, textColor: 255, fontStyle: 'bold' } },
        { content: 'HORA', styles: { fillColor: colors.red, textColor: 255, fontStyle: 'bold' } }
      ],
      [
        format(new Date(ticket.fecha), "dd/MM/yyyy"),
        format(new Date(ticket.fecha), "HH:mm"),
        'N/A',
        'N/A'
      ],
      [
        { content: '12. REALIZADO POR:', colSpan: 2, styles: { fillColor: colors.blueDark, textColor: 255, fontStyle: 'bold' } },
        { content: '16. RECIBIDO A SATISFACCIÓN:', colSpan: 2, styles: { fillColor: colors.blueDark, textColor: 255, fontStyle: 'bold' } }
      ],
      [
        { content: ticket.nombreTecnico, colSpan: 2 },
        { content: ticket.nombre, colSpan: 2 }
      ],
      [
        { content: '13. CARGO:', colSpan: 2, styles: { fillColor: colors.blueDark, textColor: 255, fontStyle: 'bold' } },
        { content: '17. CARGO:', colSpan: 2, styles: { fillColor: colors.blueDark, textColor: 255, fontStyle: 'bold' } }
      ],
      [
        { content: 'Técnico de Mantenimiento', colSpan: 2 },
        { content: 'Usuario', colSpan: 2 }
      ],
      [
        { content: '14. FIRMA:', colSpan: 2, styles: { fillColor: colors.blueDark, textColor: 255, fontStyle: 'bold', minCellHeight: 40 } },
        { content: '18. FIRMA:', colSpan: 2, styles: { fillColor: colors.blueDark, textColor: 255, fontStyle: 'bold', minCellHeight: 40 } }
      ]
    ],
    theme: 'grid',
    styles: { 
      fontSize: 8,
      lineColor: colors.blueDark,
      lineWidth: 1
    },
    margin: { left: 40, right: 40 }
  });

  doc.save(`Reporte_MTO_Ticket_${ticket.TicketId}.pdf`);
};
